import React from 'react';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles';

import { VKHRTekUIServices, ServicesProvider } from '../services';

import { createTheme, GlobalStyles } from './config';
import { Theme } from './types';

type ThemeProviderProps = Theme & {
  services?: Partial<VKHRTekUIServices>;
  children: React.ReactNode | React.ReactNode[];
};

export const VKHRTekUIProvider = ({
  services,
  children,
  ...rest
}: ThemeProviderProps) => {
  const theme = createTheme(rest);

  return (
    <MUIThemeProvider theme={theme}>
      <GlobalStyles />
      <CssBaseline />
      <ServicesProvider services={services}>{children}</ServicesProvider>
    </MUIThemeProvider>
  );
};
